var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small", "label-width": "75px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间选择：" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          size: "small",
                          type: "daterange",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "砍价状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-item selWidth mr20",
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: {
                            change: function ($event) {
                              return _vm.getList(1)
                            },
                          },
                          model: {
                            value: _vm.tableFrom.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "status", $$v)
                            },
                            expression: "tableFrom.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "进行中", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "未完成", value: 2 },
                          }),
                          _c("el-option", {
                            attrs: { label: "已成功", value: 3 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData.data, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "头像", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview" },
                          [
                            _c("el-image", {
                              staticStyle: { width: "36px", height: "36px" },
                              attrs: {
                                src: scope.row.avatar,
                                "preview-src-list": [scope.row.avatar],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发起用户",
                  prop: "nickname",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "开启时间",
                  prop: "addTime",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "砍价商品", prop: "title", "min-width": "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              trigger: "hover",
                              placement: "right",
                              "open-delay": 800,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text_overflow",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.title))]
                            ),
                            _c("div", { staticClass: "pup_card" }, [
                              _vm._v(_vm._s(scope.row.title)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "最低价",
                  prop: "bargainPriceMin",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "当前价",
                  prop: "nowPrice",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "总砍价次数",
                  prop: "peopleNum",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "剩余砍价次数",
                  "min-width": "100",
                  prop: "num",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "dataTime",
                  label: "结束时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "砍价状态", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "tag-background tag-padding",
                            class:
                              scope.row.status == 1
                                ? "doingTag"
                                : scope.row.status == 2
                                ? "notStartTag"
                                : "endTag",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("bargainStatusFilter")(scope.row.status)
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "mr10",
                            on: {
                              click: function ($event) {
                                return _vm.handleLook(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block mb20" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "查看详情",
            visible: _vm.dialogVisible,
            width: "650px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoadingPink,
                  expression: "listLoadingPink",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableDataPink.data, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "uid", label: "用户id", "min-width": "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "用户头像", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview" },
                          [
                            _c("el-image", {
                              staticStyle: { width: "36px", height: "36px" },
                              attrs: {
                                src: scope.row.avatar,
                                "preview-src-list": [scope.row.avatar],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "用户名称",
                  prop: "nickname",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "砍价金额", prop: "price", "min-width": "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "砍价时间",
                  prop: "addTime",
                  "min-width": "180",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }